import { CreateSharedLinkRequestDto, SharedTestType } from '../models/share-tests.model';
import { TestStatusEnum } from '../models/test-group.model';
import { TestResult } from '../models/test-result.model';

export class ShareTestResultsUtils {
  static prepareShareTestResultsInfo(tests: TestResult[], testType: SharedTestType): CreateSharedLinkRequestDto {
    const shareableTests = testType === SharedTestType.LNT ? this.filterLntResultsForSharing(tests) : this.filterMntResultsForSharing(tests);

    return {
      testIds: shareableTests.map(row => row.id),
      testType,
    };
  }

  static filterMntResultsForSharing(tests: TestResult[]): TestResult[] {
    return tests.filter(test => test.testStatus === TestStatusEnum.POSITIVE);
  }

  static filterLntResultsForSharing(tests: TestResult[]): TestResult[] {
    const statuses = [TestStatusEnum.POSITIVE, TestStatusEnum.SENDER_REPLACED, TestStatusEnum.TEXT_REPLACED];
    return tests.filter(test => statuses.includes(test.testStatus));
  }

  static hasForbiddenTestsToShare(tests: TestResult[], testType: SharedTestType): boolean {
    if (tests.length === 0) return false;
    const shareableTests = testType === SharedTestType.LNT ? this.filterLntResultsForSharing(tests) : this.filterMntResultsForSharing(tests);

    if (shareableTests.length === tests.length) return false;

    return true;
  }

  static getShareTestsTooltipLabel(selectedTests: TestResult[], hasForbiddenTestsToShare: boolean) {
    const hasSelectedRows = selectedTests.length > 0;

    if (hasForbiddenTestsToShare) {
      return 'Sharing is disabled because TelQ could not confirm delivery to the handset for some of the selected tests.';
    }

    if (!hasSelectedRows) {
      return 'You must select tests to generate a shareable link.';
    }

    return 'Create shareable link for tests';
  }
}
